<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
            text-key="name"
            value-key="id"
            :search="true"
            :multiple="multiple"
  >

    <template v-if="scope.option" slot="value" slot-scope="scope">
      {{scope.option.name || "بی نام..."}}
    </template>
    <template slot="option" slot-scope="scope">
      <div class="imageWithName">
            <span class="dropdown-item-text">
              <b>{{scope.option.name || "---"}} </b>
            </span>

        <div class="dropdown-item-text">
          <img class="icon"
               v-if="scope.option.path"
               :src="`${media_url}/${scope.option.path}?max=40`"/>

          <div v-else><i class="far fa-user-circle defaultIcon"/></div>
        </div>
      </div>

    </template>
  </fvSelect>
</template>

<script>
  import {mapActions} from "vuex"
  import {API_MEDIA_URL} from "../env"

  export default {
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      id: {
        type: String
      },
      value: {
        type: String,
        default: undefined
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        ...mapActions('main', [
          'crud'
        ]),
        options: [],
        media_url: API_MEDIA_URL
      }
    },
    created() {
      this.getData()
    },
    computed: {
      valData: {
        get() {
          return this.value || undefined
        },
        set(value) {
          this.$emit('input', value || '' )
        }
      }
    },
    methods: {
      async getData() {
        try {
          const avatars = await this.crud({
            action: 'get',
            section: 'avatars',
            perPage: 50
          })
          if (avatars.data && avatars.data.items) {
            const result = avatars.data.items
            this.options = result
          }
        } catch (e) {
          // console.log(e)
        }
      }
    }
  }
</script>

<style lang="scss">

</style>
